import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { PaysafeFormField } from '../../models/paysafe/paysafe-form-field.enum';
import { PaysafeFormValue } from '../../models/paysafe/paysafe-form-value.type';

export const mockPaysafeFormValue: PaysafeFormValue = {
  [PaysafeFormField.BillingAddress]: {
    ...mockCustomerDetails.address,
    sameAsAddress: false,
  },
  [PaysafeFormField.AccountName]: `${mockCustomerDetails.firstName} ${mockCustomerDetails.surname}`,
  [PaysafeFormField.Address]: mockCustomerDetails.address,
  [PaysafeFormField.CardNumber]: null,
  [PaysafeFormField.Cvv]: null,
  [PaysafeFormField.ExpiryDate]: null,
  [PaysafeFormField.MonthlyRenewal]: false,
  [PaysafeFormField.PaperlessPreference]: null,
  [PaysafeFormField.TermsAndConditions]: true,
};
